import { rateLineListQuerySchema, type RateLineListQuery } from '@chukua/common';
import { useCallback, useMemo } from 'react';
import { useListQuery } from '../../../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../../../shared/hooks/use-paged-list';
import { listRateLines } from '../../../rate-cards.api';

/**
 * A card's lines for the URL's list query. The tab shows what is in force until told otherwise, so an absent
 * `current` is asked for as `true`; "superseded" is `current=false` and goes to the server like any other filter.
 */
export function useRateLines(rateCardId: string) {
  const list = useListQuery(rateLineListQuerySchema);
  const query = useMemo<RateLineListQuery>(() => ({ ...list.query, current: list.query.current ?? true }), [list.query]);
  const load = useCallback((q: RateLineListQuery) => listRateLines(rateCardId, q), [rateCardId]);
  return { list, query, ...usePagedList(query, load) };
}
